import React, { FC } from "react";
import { Box } from "@mui/material";

import { useAuth, useOrgLinkBranding } from "../../../contexts/AuthContext";
import LogoContent from "./LogoContent";

const logoBoxSx = {
  display: "flex",
  alignItems: "center",
  maxHeight: 40,
  maxWidth: "100%",
  overflow: "hidden",
  "& img": {
    display: "block",
    maxHeight: 40,
    width: "auto",
    maxWidth: "100%",
    objectFit: "contain",
  },
} as const;

const OrgLogo: FC = () => {
  const { is_external, user } = useAuth();
  const { logoUrl, whitelabel } = useOrgLinkBranding();
  const tenant = user?.backend?.current_tenant;
  const orgName = tenant?.organization?.name ?? "";

  if (logoUrl) {
    return (
      <Box sx={logoBoxSx}>
        <img src={logoUrl} alt={orgName} />
      </Box>
    );
  }

  if (is_external) {
    return (
      <Box
        sx={logoBoxSx}
        dangerouslySetInnerHTML={{ __html: tenant?.letter_format?.header ?? "" }}
      />
    );
  }

  if (whitelabel) {
    return (
      <Box
        component="span"
        sx={{
          fontSize: "1.5rem",
          fontWeight: 700,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {orgName}
      </Box>
    );
  }

  return <LogoContent />;
};

export default OrgLogo;
